import React from 'react';
import Select, { createFilter } from 'react-select';

const customFilter = createFilter({
    ignoreAccents: true,
    matchFrom: 'start',
});

// styleProxy is used to override react-select's style property to reduce injected emotion inline styles.
const styleProxy = new Proxy(
    {},
    {
      get: (target, propKey) => () => {}
    }
);

// OwnersEdge app implements custom classNames for react-select instead of using emotion injected styles.
const customClassNames = {
    control: () => 'select-search-control',
    clearIndicator: (componentState) => {
        if(componentState.isFocused) {
            return 'select-search-clear-indicator-focus';
        }
        return 'select-search-clear-indicator';
    },
    placeholder: () => 'select-search-placeholder',
    container: () => 'select-search-container',
    dropdownIndicator: (componentState) => {
        if(componentState.isFocused) {
            return 'select-search-dropdown-indicator-focus';
        }
        return 'select-search-dropdown-indicator';
    },
    menu: () => 'select-search-menu',
    menuList: () => 'select-search-menu-list',
    valueContainer: () => 'select-search-value-container',
    placeholder: () => 'select-search-placeholder',
    indicatorsContainer: () => 'select-search-indicators-container',
    indicatorSeparator: () => 'select-search-indicator-separator',
    option: (componentState) => {
        if (componentState.isSelected) {
            return 'select-search-option-selected';
        }
        if (componentState.isFocused) {
            return 'select-search-option-focus';
        }
        return 'select-search-option';
    },
    singleValue: () => 'select-search-single-value',
}

/**
 * The react-select input component was adding inline-styles even when defining custom classNames.
 * So the below customInput component is similar to the react-select version except with the inline
 * styles removed.
 */
const customInput = (props) => {
    const { value, innerRef, isDisabled, onChange, onFocus, onBlur } = props;
    
    return (
        <div
            className="select-search-input"
        >
            <input
                ref={innerRef}
                disabled={isDisabled}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                value={value}
            />
        </div>
    );
};
  

class SelectSearchContainer extends React.Component {
    constructor(props) {
        super(props);

        // TODO: I'm not sure this component even uses state
        this.state = { options: [] };

        this.mapOptions = this.mapOptions.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    mapOptions(optionsArr, labelColumn, valueColumn) {
        const mappedOptions = optionsArr.map(option => {
            return {
                label: option[labelColumn],
                value: option[valueColumn]
            };
        });
        return mappedOptions;
    }

    handleChange(e) {
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    render() {
        const options = this.mapOptions(
            this.props.options,
            this.props.labelColumn,
            this.props.valueColumn
        )
          
        return (
            <Select
                classNamePrefix='select-search'
                classNames={customClassNames}
                styles={styleProxy}
                options={options}
                isSearchable
                onChange={this.handleChange}
                value={options.filter(({ value }) => value === this.props.value)}
                id={this.props.id || 'react-select'}
                placeholder={this.props.placeHolder ? this.props.placeHolder : "Select Brokerage..."}
                filterOptions={customFilter}
                isClearable
                unstyled
                components={{
                    Input: customInput
                }}
            />
        );
    }
}

export default SelectSearchContainer;
